import { ref } from 'vue';
import store from 'dashboard/store';
import { crmmFeatures, loadCrmmFeatures } from './crmmFeatures';
// NUNCA chamar loadCrmmFeatures() no module-eval: roda antes de window.axios existir, o catch
// engole e loaded=true envenena o single-flight (zero /crmm/config pra TODOS — bug agenda40).
// Load LAZY no render via crmmSpyEligible (axios garantido).
export const crmmSpy = ref(true); // Modo Spy ATIVADO por padrao (seguro)
export function crmmSpyEligible() {
  try {
    if (window.axios) loadCrmmFeatures();
    const u = store.getters.getCurrentUser;
    return !!(u && u.role === 'administrator' && crmmFeatures.value.spy === true);
  } catch (e) { return false; }
}
export function crmmSpyOn() { return crmmSpyEligible() && crmmSpy.value; }
export function crmmToggleSpy() { if (crmmSpyEligible()) crmmSpy.value = !crmmSpy.value; }
// D13 (LGPD): trilha de acesso do Spy. Loga 1 evento por MUDANCA de conversa vista em spy — dedup,
// pois o chokepoint (markMessagesRead) dispara por mensagem tambem. Best-effort: erro nunca quebra a UI.
let __lastSpyConv = null;
export function crmmSpyLog(conversationId) {
  if (!conversationId || conversationId === __lastSpyConv) return;
  __lastSpyConv = conversationId;
  try {
    const accountId = window.location.pathname.split('/')[3];
    if (window.axios) window.axios.post('/api/v1/accounts/' + accountId + '/crmm/spy-log', { conversation_id: conversationId }).catch(() => {});
  } catch (e) { /* best-effort */ }
}
if (typeof window !== 'undefined') {
  window.__crmmSpyActive = () => crmmSpyOn();
  window.__crmmSpyLog = crmmSpyLog;
}
